// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rw-2";
export var messageContent = "_rw-0";
export var messagesScroll = "_rw-1";
export var shimmer = "_rw-3";
export var shimmerW100 = "_rw-4";
export var shimmerW70 = "_rw-8";
export var shimmerW80 = "_rw-7";
export var shimmerW85 = "_rw-6";
export var shimmerW90 = "_rw-5";